import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { IDevicePicture } from '@app/api/interfaces/device-picture.interface';
import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

export interface IFpLoggerNoisePicturesState {
  currentTab: FpLoggerNoiseTabs.Pictures;
  date: string | null;
  popupMainData: ILdLogger | null;
  data: IDevicePicture[] | null;
  loading: boolean;
  pictureUpdateLoading: boolean;
  error: IApiBaseErrorResponse | null;
}

export const initialFpLoggerNoisePicturesState: IFpLoggerNoisePicturesState = {
  currentTab: FpLoggerNoiseTabs.Pictures,
  date: null,
  popupMainData: null,
  data: null,
  loading: false,
  pictureUpdateLoading: false,
  error: null,
};
